export *  from './daily-staging-pay-view.component'